<template>
    <div class="finale">
        <div class="results-box">
            <medal :medalType="medal" :medalInfo="medalDescription"/>
        </div>
        <div class="row result-row">
            <div class="col c24 b3c12">
                <div class="results-box" >
                    <badge :earned="establishBadge" icon="star" />
                    <div class="" v-html="establishText"></div>
                </div>
            </div>
            <div class="col c24 b3c12">
                <div class="results-box">
                    <badge :earned="rolemodelBadge" icon="check" />
                    <div class="" v-html="roleModelText"></div>
                </div>
            </div>
        </div>
        
        <div class="learnapply">
            <h3>Learn and Apply</h3>
            <p>Continue developing your business prowess by viewing our <a href="https://portal.insightxp.com/portal.html?space=itg" target="_blank">resources to hone your skills</a>.</p>
        </div>
        <div class="sticky-footer">
            <button @click="replay" class="btn center noselect">Replay</button>
        </div>
        
        <div id="featureBackground" class="confetti"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { gsap } from '/src/assets/js/gsap'
import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin'
import { Physics2DPlugin } from '/src/assets/js/gsap/Physics2DPlugin'
import axios from 'axios';

import Badge from '@/components/Badge.vue'
import Medal from '@/components/Medal.vue'
// import EffectivenessRibbonFeedback from '@/components/EffectivenessRibbonFeedback.vue'
// import ChartFeedback from '@/components/ChartFeedback.vue'
// import ShowSelections from '@/components/ShowSelections.vue'

var FormData = require('form-data');

export default {
    name: "Complete",
    components : {
        'medal': Medal,
        'badge': Badge
        // 'effectiveness-ribbon-feedback' : EffectivenessRibbonFeedback,
        // 'chart-feedback' : ChartFeedback,
        // 'show-selections' : ShowSelections
    },
    data: function () {
        return {
            medal: '',
            establishText: '',
            establishBadge: false,
            roleModelText: '',
            rolemodelBadge: false,
            medalDescription: ''
        }
    },
    computed: {
        ...mapGetters([
            "getState",
            "getUserType",
            "getSimName",
            "playerSelections",
            "getScoring"
        ])
    },
    mounted () {
        const playerSelections = this.playerSelections[0][0];
        let score = 0;
        
        // Establish Badge
        let establish = playerSelections.filter( pSelect => {
            return pSelect.dimensions.establish === true
        })
        console.log("Establish selection count: ", establish.length)
        this.establishBadge = establish.length >= 3
        console.log("Does user get establish badge?", this.establishBadge ? "Yes" : "No")
        this.establishText = this.establishBadge ? this.getScoring.establish.badge : this.getScoring.establish.nobadge

        // Role Model Badge
        let rolemodel = playerSelections.filter( pSelect => {
            return pSelect.dimensions.model === true
        })
        this.rolemodelBadge = rolemodel.length > 0
        console.log("Does user get Role Model badge?", this.rolemodelBadge ? "Yes" : "No")
        this.roleModelText = this.rolemodelBadge ? this.getScoring.model.badge : this.getScoring.model.nobadge

        // User score/medal
        playerSelections.map( pSelect => {
            score += pSelect.dimensions.points
        })
        console.log('user score', score)
        let medal = ""
        let scoring = this.getScoring.points.options
        
        Object.keys( scoring ).forEach( k => {
            const min = scoring[ k ].conditions.range.min
            const max = scoring[ k ].conditions.range.max

            if( score >= min && score <= max ){
                medal = k
            }
        } )
        
        this.medal = medal
        this.medalDescription = scoring[medal].description
        

        
        gsap.registerPlugin(ScrollToPlugin, Physics2DPlugin);
        this.$parent.appHeight();
        gsap.to(window, {duration: 0.5, scrollTo: 0, delay: .2, ease: "sine.inOut"});
        this.doConfetti();
        this.setEndTime();

        gsap.delayedCall(0.75, this.sendData);
    },
    methods: {
        ...mapActions([
            "setEndTime",
            'reset'
        ]),
        replay() {
            // animate out, then reset, 
            gsap.to('.finale', {autoAlpha: 0, duration: 0.5, ease: "sine.inOut"})
            gsap.delayedCall(0.75, this.reset);
            gsap.delayedCall(1, this.goHome);
        },
        goHome() {
            this.$router.push({ path: "/" });
        },
        sendData () {
            var data = new FormData();
            var payload = JSON.stringify(this.getState);
            data.append('value', payload);

            var config = {
                method: 'post',
                url: `https://engine.insightxp.com/pdata?sim=${this.getSimName}&key=${this.getUserType}`,
                data : data
            };

            axios(config)
                .then(function (response) {
                    // console.log(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    // console.log(error);
                });

        },
        doConfetti() {
            let dots = [],
            bg = document.querySelector("#featureBackground"),
            i, dot;

            // create 80 dot elements and put them in an array
            for (i = 0; i < 80; i++) {
                dot = document.createElement("div");
                    dot.setAttribute("class", "dot");
                    bg.appendChild(dot);
                    dots.push(dot);
            }

            //set the initial position of all the dots, and pick a random color for each from an array of colors
            gsap.set(dots, {
                backgroundColor: "random([#01aded, #f45537, #b4d236, #f08fae, #f5a421])",
                scale: "random(0.1, 0.35)",
                skewX: "random(20, 50)",
                height: "random(10px, 50px)",
                transformOrigin: 'center center',
                x: '50vw',
                y: '-20vh'
            });

            // create the physics2D animation
            gsap.to(dots, {
                duration: 5,
                rotation: "random(0, 5) * 360 + random(0, 360)",
                physics2D: {
                    velocity: 20,
                    angle: "random(0, 180)",
                    gravity: 50,
                },
                delay: "random(0, 1.5)"
            });
        }
    }
};
</script>